// extracted by mini-css-extract-plugin
export default {"mobMenu":"MobileMenu_mobMenu__uB8Sf"};